import React, { useEffect, useState } from 'react'
import EmployeeAttendanceCard from '../components/EmployeeAttendenceCard'
import * as api from '../utils/api/apiClient'
import { toast } from 'react-toastify'
import { FcEmptyTrash } from 'react-icons/fc'
// import { CiCalendarDate } from 'react-icons/ci'
import { Loading } from '../components/Loading'
import { useNavigate } from 'react-router-dom'
import { GoPlus } from 'react-icons/go'

const Attendance = () => {
  const navigate = useNavigate()
  const [employees, setEmployees] = useState([])
  const [loading, setLoading] = useState(true)
  const [filteredEmployees, setFilteredEmployees] = useState([])
  const [allEmployees, setAllEmployees] = useState([])
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedEmployee, setSelectedEmployee] = useState(null)
  const [attendanceState, setAttendanceState] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [remark, setRemark] = useState('')
  const [timing, setTiming] = useState('')
  const [selectedDate, setSelectedDate] = useState(new Date())
  // const [showCalendar, setShowCalendar] = useState(false)

  // date YYYY-MM-DD formate in convert function
  const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  // one date range function
  const getDateRange = (date) => {
    const from = formatDate(date)
    const nextDate = new Date(date)
    nextDate.setDate(date.getDate() + 1)
    const to = formatDate(nextDate)
    return { from, to }
  }

  // employee total count
  const totalEmployees = employees?.length || 0
  const totalPresent = filteredEmployees.length || 0

  // present employee filter useEffect
  useEffect(() => {
    if (Array.isArray(employees) && employees.length > 0) {
      const presentEmployees = employees.filter(
        (emp) => emp.status?.toLowerCase() === 'present'
      )
      setFilteredEmployees(presentEmployees)
    } else {
      setFilteredEmployees([])
    }
  }, [employees])

  // select one  employee  function
  const handleEmployeeClick = (employee) => {
    setSelectedEmployee(employee)
    setIsModalOpen(true)
    setIsDropdownOpen(false)
  }

  const handleSubmitAttendance = async () => {
    if (!selectedEmployee || !attendanceState) return

    try {
      setSubmitting(true)
      const now = timing || new Date().toISOString()

      const payload = {
        employee_id: selectedEmployee.id,
        at: now,
        state: attendanceState.toLowerCase(),
        remark: remark,
      }

      await api.addCoustomAttendance(payload)

      setIsModalOpen(false)
      setAttendanceState('')
      setRemark('')
      setTiming('')
      setSelectedEmployee(null)
      toast.success('Feed Attendance Successfully')

      const dateRange = getDateRange(selectedDate)
      await fetchAllAttendances(dateRange.from, dateRange.to)
    } catch (error) {
      console.log(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    } finally {
      setSubmitting(false)
    }
  }

  // get all employee function
  const fetchAllEmployee = async () => {
    try {
      const res = await api.getAllEmployees()
      setAllEmployees(res.data.employees)
    } catch (error) {
      console.log(error)
      setAllEmployees([])
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    }
  }

  // get all attendance function
  const fetchAllAttendances = async (from, to) => {
    try {
      setLoading(true)
      const res = await api.getAllAttendances(from, to)
      setEmployees(res.data)
    } catch (error) {
      console.error(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    } finally {
      setLoading(false)
    }
  }

  // attendance delete function
  const deleteEmployeeAttendance = async (id) => {
    try {
      setDeleting(true)
      await api.deleteAttendance(id)
      const dateRange = getDateRange(selectedDate)
      await fetchAllAttendances(dateRange.from, dateRange.to)
      toast.success('Delete Attendance Successfully')
    } catch (error) {
      console.log(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    } finally {
      setDeleting(false)
    }
  }

  // yesterday date attendance function
  const handlePrevDay = () => {
    const prevDate = new Date(selectedDate)
    prevDate.setDate(selectedDate.getDate() - 1)
    setSelectedDate(prevDate)
    const dateRange = getDateRange(prevDate)
    fetchAllAttendances(dateRange.from, dateRange.to)
  }

  // tomorrow date attendance function
  const handleNextDay = () => {
    const nextDate = new Date(selectedDate)
    nextDate.setDate(selectedDate.getDate() + 1)
    setSelectedDate(nextDate)
    const dateRange = getDateRange(nextDate)
    fetchAllAttendances(dateRange.from, dateRange.to)
  }

  // today date attendance function
  const handleToday = () => {
    const today = new Date()
    setSelectedDate(today)
    const dateRange = getDateRange(today)
    fetchAllAttendances(dateRange.from, dateRange.to)
  }

  // calender select date attendance function
  const handleDateSelect = (date) => {
    const selectedDate = new Date(date)
    setSelectedDate(selectedDate)
    // setShowCalendar(false)
    const dateRange = getDateRange(selectedDate)
    fetchAllAttendances(dateRange.from, dateRange.to)
  }

  // current data attendance useEffect
  useEffect(() => {
    const initializeData = async () => {
      setLoading(true)
      const dateRange = getDateRange(new Date())
      await Promise.all([
        fetchAllEmployee(),
        fetchAllAttendances(dateRange.from, dateRange.to),
      ])
      setLoading(false)
    }
    initializeData()
  }, [])

  // employee navigate employee details
  const handleNameClick = (id) => {
    navigate(`/employee/${id}`)
  }

  if (loading) {
    return <Loading />
  }

  return (
    <div className='container mx-auto p-6 bg-cream h-max'>
      {/* header */}
      <div className='flex justify-between'>
        <h1 className='text-2xl text-brown font-bold'>Employees</h1>
        <div className='relative'>
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className='bg-tan p-2 flex items-center gap-2 text-white hover:bg-gold cursor-pointer rounded-md'
          >
            <GoPlus size={20} /> Add Attendance
          </button>
        </div>
      </div>
      {/* select one  employee DropdownOpen  */}
      {isDropdownOpen && (
        <div className='absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg z-50 max-h-96 overflow-y-auto'>
          <div className='py-1'>
            {allEmployees.length > 0 ? (
              allEmployees.map((employee) => (
                <div
                  key={employee.id}
                  onClick={() => handleEmployeeClick(employee)}
                  className='px-4 py-2 hover:bg-tan hover:bg-opacity-20 cursor-pointer flex items-center gap-2'
                >
                  <div className='text-sm font-medium text-gray-900'>
                    <span>{employee.name}</span> -{' '}
                    <span>{employee.work_id}</span>
                  </div>
                </div>
              ))
            ) : (
              <div className='px-4 py-2 text-sm text-gray-500'>
                No employees found.
              </div>
            )}
          </div>
        </div>
      )}
      {/* status card*/}
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-6 my-4'>
        {/* total employee card */}
        <div className='bg-gradient-to-br from-cream to-beige rounded-xl shadow-md p-6 border border-tan relative overflow-hidden group'>
          <div className='absolute -top-10 -left-10 w-32 h-32 bg-tan opacity-20 rounded-full transform scale-110 group-hover:scale-125 transition-transform duration-300'></div>
          <div className='relative z-10'>
            <h2 className='text-xl sm:text-xl font-semibold text-brown mb-4'>
              Total Employees
            </h2>
            <p className='text-xl sm:text-3xl font-bold text-olive'>
              {totalEmployees}
            </p>
          </div>
        </div>

        {/* present employee card */}
        <div className='bg-gradient-to-br from-cream to-beige rounded-xl shadow-md p-6 border border-tan relative overflow-hidden group'>
          <div className='absolute -top-10 -right-10 w-32 h-32 bg-tan opacity-20 rounded-full transform scale-110 group-hover:scale-125 transition-transform duration-300'></div>
          <div className='relative z-10'>
            <h2 className='text-xl sm:text-xl font-semibold text-brown mb-4'>
              Present At {formatDate(selectedDate)}
            </h2>
            <p className='text-xl sm:text-3xl font-bold text-olive'>
              {totalPresent}
            </p>
          </div>
        </div>
      </div>

      {/* date navigation */}
      <div className='bg-tan/30 flex justify-between border border-brown rounded-md p-4 mb-4'>
        <div className='flex gap-2'>
          <button
            onClick={handlePrevDay}
            className='bg-tan rounded-md py-2 px-4 text-white hover:bg-tan/80'
          >
            Prev
          </button>
          <button
            onClick={handleNextDay}
            className='bg-tan rounded-md py-2 px-4 text-white hover:bg-tan/80'
          >
            Next
          </button>
          <button
            onClick={handleToday}
            className='bg-tan rounded-md py-2 px-4 text-white hover:bg-tan/80'
          >
            Today
          </button>
        </div>
        {/* <div className='relative'>
          <button
            onClick={() => setShowCalendar(!showCalendar)}
            className='bg-tan rounded-md py-2 px-4 text-white hover:bg-tan/80 flex items-center gap-2'
          >
            <CiCalendarDate size={16} />
            {formatDate(selectedDate)}
          </button>

          {showCalendar && (
            <div className='absolute right-0 mt-2 bg-white rounded-lg shadow-lg p-4 z-50'>
              <input
                type='date'
                value={formatDate(selectedDate)}
                onChange={(e) => handleDateSelect(e.target.value)}
                className='p-2 border rounded-md'
              />
            </div>
          )}
        </div> */}
        {/* ** */}
        <div className='relative'>
          <div className='text-white'>
            <input
              type='date'
              value={formatDate(selectedDate)}
              onChange={(e) => handleDateSelect(e.target.value)}
              className='bg-tan rounded-md py-2 px-4 text-white hover:bg-tan/80'
            />
          </div>
        </div>
        {/* ** */}
      </div>

      {/* employee card  */}
      <div>
        {employees?.length > 0 ? (
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
            {employees.map((employee) => (
              <EmployeeAttendanceCard
                key={employee.id}
                onDelete={deleteEmployeeAttendance}
                data={employee}
                isDeleting={deleting}
                clicked={() => handleNameClick(employee.employee_id)}
              />
            ))}
          </div>
        ) : (
          <div className='col-span-full w-full my-8 bg-gradient-to-br from-cream to-beige rounded-lg border border-tan h-96 md:h-[500px] flex justify-center items-center'>
            <div className='text-center'>
              <FcEmptyTrash className='mx-auto h-16 w-16 md:h-24 md:w-24 text-red-500' />
              <p className='text-xl md:text-2xl text-brown mt-4'>
                Not Present Today
              </p>
              <p className='text-base md:text-xl text-brown mt-2'>
                Something went wrong!
              </p>
            </div>
          </div>
        )}
      </div>
      {/* Attendance Modal */}
      {isModalOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
          <div className='bg-white p-6 rounded-lg shadow-xl w-96'>
            <h2 className='text-xl font-bold mb-4'>Add attendance</h2>

            <div className='space-y-4'>
              <div>
                <label className='block mb-2 font-medium'>
                  Attendance State for {selectedEmployee?.name}
                </label>
                <select
                  value={attendanceState}
                  onChange={(e) => setAttendanceState(e.target.value)}
                  className='w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                  required
                >
                  <option value=''>Select attendance state</option>
                  <option value='entry'>Present Entry</option>
                  <option value='exit'>Present Exit</option>
                  <option value='absent'>Absent</option>
                  <option value='holiday'>Holiday</option>
                  <option value='cl'>Casual Leave (CL)</option>
                  <option value='ml'>Medical Leave (ML)</option>
                  <option value='el'>Earned Leave (EL)</option>
                </select>
              </div>

              <div>
                <label className='block mb-2 font-medium'>Timing</label>
                <input
                  type='datetime-local'
                  value={
                    timing ? new Date(timing).toISOString().slice(0, 16) : ''
                  }
                  onChange={(e) =>
                    setTiming(new Date(e.target.value).toISOString())
                  }
                  className='w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                />
              </div>

              <div>
                <label className='block mb-2 font-medium'>Remarks</label>
                <textarea
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder='Enter remarks (optional)'
                  className='w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 h-24 resize-none'
                />
              </div>
            </div>

            <div className='flex justify-end space-x-2 mt-6'>
              <button
                onClick={() => {
                  setIsModalOpen(false)
                  setAttendanceState('')
                  // setAttendanceType('')
                  setRemark('')
                  setTiming('')
                  setSelectedEmployee(null)
                }}
                className='px-4 py-2 bg-rust text-white rounded hover:bg-rust/50 transition'
                disabled={submitting}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitAttendance}
                className='px-4 py-2 bg-tan text-white rounded hover:bg-gold transition'
                disabled={submitting || !attendanceState}
              >
                {submitting ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default Attendance
